import { CreateNS } from '../lib/createAPIBuilder';

export const installAPIBrand = (namespace: CreateNS) => {
    namespace('brand')(({ func, prop, deps }) => {
        prop('brandName', deps.getBrandName, null);
        func('updateBrand', deps.updateBrand);
    });
};
